























































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'forms', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      delivery_zone_group_id: {  },
      purpose: { required },
      costs: { required },
      date: { required },
    }

    return {
      form: rules
    }
  }
})
export default class TransportCostsManyForm extends Vue {
  forms!: any[]

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/prepareNew`, {});
  }

  changeValue(index: any, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      index, field, newValue: value
    });
  }

  addForm() {
    this.$store.dispatch(`${STORE_KEY}/addForm`)
  }

  copyForm(idx: any) {
    console.log(idx)
    this.$store.dispatch(`${STORE_KEY}/copyForm`, {idx})
  }

  delForm(idx: any) {
    this.$store.dispatch(`${STORE_KEY}/delForm`, {idx})
  }

  saveFormData() {
    this.$store.dispatch(`${STORE_KEY}/saveForm`)
    .then((result) => {
      this.$buefy.snackbar.open(`Данные успешно сохранены`);

      this.$emit('form-close');
      (this.$parent as any).close();
    })
    .catch(() => {
      this.$buefy.snackbar.open({
        type: 'is-warning',
        message: `При сохранении возникли проблемы. Попробуйте позже.`
      })
    })
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

